import PropTypes from "prop-types";
import { Box, FormGroup, FormLabel } from '@mui/material';
import { makeStyles } from "@mui/styles";

import React, { useContext } from 'react';
import themeMaker, {bssMakeStyles,  width2Breakpoint } from '../../lib/theming';
import CercaComune from './CercaComune';
import CercaNazione from './CercaNazione';
import BSSStyleContext from "../../contexts/BSSStyleContext";
import BSSPreventivoContext from "../../contexts/BSSPreventivoContext";
import { Grid } from "@mui/material";

const Localita = ({title, name, methods}) => {

    const classes = bssMakeStyles();

    const {nazioni} = useContext(BSSPreventivoContext);

    const {mainContainerWidth, theme} = useContext(BSSStyleContext);
    const cw = width2Breakpoint(mainContainerWidth, theme)
    const mbcfg = {xs: "0.5em", sm: "0.5em", md: "0.5em"}[cw]
    const wcfg = {
        nazione: {xs: 1, sm: 1, md: 1/3, lg: 1/3}[cw],
        comune: {xs: 1, sm: 1, md: 2/3, lg: 2/3}[cw],
    }

    return (
        <>
            <FormLabel className={classes.label}>{title}</FormLabel>

            <Box pt={1.5}>                
                
                <Grid container direction="row">
                    <Grid item sx={{width: wcfg.nazione, mb: mbcfg}}>
                        <CercaNazione name={`nazione_${name}`} nazioni={nazioni} methods={methods} />
                    </Grid>
                    <Grid item sx={{width: wcfg.comune, mb: mbcfg}}>
                        <CercaComune name={`comune_${name}`} dependsOn={[`nazione_${name}`]}  methods={methods} />
                    </Grid>
                </Grid>
            </Box>
            
            
        </>
    )
}

Localita.propTypes = {
    title: PropTypes.string,
    name: PropTypes.string
}


export default Localita;

